
import React from 'react';
import {map, max, min, round, isEmpty, pick, flattenDeep, values} from 'lodash';

// we can have different combination of colors added here
import {ColorBlend} from './color-blend.js';
import {isFloat} from './number-util.js';

export const getHeatMapColorEquivalentOf = (hmData, config, isFontColor = false) => {
    // TODO: this function needs a bit of refactoring
    const heatMapConfig = config.configHeatMap || {};
    const configTree = config.configTree;
    let lowMidHighColors;

    const hMapData = getHmData(hmData, heatMapConfig.heatMapColumns, configTree);
    let heatMapData = flattenDeep(hMapData.map(o => values(o)));
    if(configTree.isSubRows) {
        // TODO: this is a shortcut method and need to find a better way to achieve this
        heatMapData = flattenDeep(heatMapData.map(o => values(o)));
    }

    if(isFontColor) {
        lowMidHighColors = isEmpty(heatMapConfig.fontColors) ? {low: '#000000', mid: '#000000', high: '#000000'} : heatMapConfig.fontColors;
    } else {
        lowMidHighColors = isEmpty(heatMapConfig.colors) ? {low: '#C4ECFF', mid: heatMapConfig.isZeroMidPoint ? '#FFFFFF' : '#79CAF2', high: '#206080'} : heatMapConfig.colors;
    }

    const minMidMaxValue = getMinMidMaxValues(heatMapData, heatMapConfig.isZeroMidPoint);
    const colorRange = getColorRange(minMidMaxValue, lowMidHighColors, heatMapConfig.isZeroMidPoint);

    return val => val === undefined ? val :
        (heatMapConfig && heatMapConfig.isHtmlEmbedded ? getHeatMapHtmlEmbedded(val, valueToColor(val, minMidMaxValue, colorRange, heatMapConfig.isZeroMidPoint)) : valueToColor(val, minMidMaxValue, colorRange, heatMapConfig.isZeroMidPoint));
};

const getHmData = (hmData, hmKeys, configTree) => {
    const childKey = configTree.childKey || 'subRows';
    return configTree.isSubRows ? pickHmDataFromNestedData(hmData, hmKeys, childKey) : pickHmData(hmData, hmKeys);
};

const pickHmDataFromNestedData = (hmData, hmKeys, childKey) => {
    return map(hmData, eachData => isEmpty(eachData[childKey]) ? pickHmData([eachData], hmKeys) : pickHmDataFromNestedData(eachData[childKey], hmKeys, childKey));
};

const pickHmData = (dataSet, hmKeys) => map(dataSet, eachData => pick(eachData, hmKeys));

const getHeatMapHtmlEmbedded = (val, valToColor) => <div className='spark-text-center' style={{'background-color': valToColor}}>{val}</div>;

const getMinMidMaxValues = (heatMapData, isZeroMidPoint) => {
    let minVal = 0;
    let maxVal = 0;
    let midVal = 0;
    let isFloatValue = false;
    if (heatMapData && heatMapData.length > 0) {
        const minData = min(heatMapData);
        const maxData = max(heatMapData);

        if(isFloat(minData) || isFloat(maxData)) {
            minVal = minData * 100;
            maxVal = maxData * 100;
            isFloatValue = true;
        } else {
            minVal = round(minData);
            maxVal = round(maxData);
        }

        if(isZeroMidPoint === true) {
            minVal = minVal < 0 ? minVal : 0;
            maxVal = maxVal > 0 ? maxVal : 0;
        } else {
            midVal = round((minVal + maxVal) / 2);
        }
    }

    return {
        minValue: minVal,
        maxValue: maxVal,
        midValue: midVal,
        isFloatValue: isFloatValue
    };
};

const getColorRange = (minMidMax, colors, isZeroMidPoint) => {
    let range;
    const diff = minMidMax.maxValue - minMidMax.minValue;
    if(minMidMax.isFloatValue) {
        range = diff % 2 === 0 ? (diff - 1) : diff;
    } else {
        range = diff / 2;
    }

    if(isZeroMidPoint === true) {
        return {
            lowRange: ColorBlend.blendRange(colors.mid, colors.low, -minMidMax.minValue),
            highRange: ColorBlend.blendRange(colors.mid, colors.high, minMidMax.maxValue)
        };
    } else {
        return {
            lowRange: ColorBlend.blendRange(colors.low, colors.mid, range),
            highRange: ColorBlend.blendRange(colors.high, colors.mid, range)
        };
    }
};

const valueToColor = (val, minMidMax, colorRange, isZeroMidPoint) => {
    const toConvert = minMidMax.isFloatValue ? (val * 100) : round(val);

    if(isZeroMidPoint === true) {
        return toConvert <= minMidMax.midValue ? colorRange.lowRange[-toConvert] : colorRange.highRange[toConvert];
    } else {
        return toConvert <= minMidMax.midValue ? colorRange.lowRange[round(toConvert - minMidMax.minValue)] : colorRange.highRange[round(minMidMax.maxValue - toConvert)];
    }
};
